import { __extends } from "tslib";
import { CreateStreamProcessorRequest, CreateStreamProcessorResponse } from "../models/models_0";
import { deserializeAws_json1_1CreateStreamProcessorCommand, serializeAws_json1_1CreateStreamProcessorCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateStreamProcessorCommand = /** @class */ (function (_super) {
    __extends(CreateStreamProcessorCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateStreamProcessorCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateStreamProcessorCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "RekognitionClient";
        var commandName = "CreateStreamProcessorCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateStreamProcessorRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateStreamProcessorResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateStreamProcessorCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1CreateStreamProcessorCommand(input, context);
    };
    CreateStreamProcessorCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1CreateStreamProcessorCommand(output, context);
    };
    return CreateStreamProcessorCommand;
}($Command));
export { CreateStreamProcessorCommand };
//# sourceMappingURL=CreateStreamProcessorCommand.js.map